const amountOptions = {
  numeral: true,
  numericOnly: true,
  delimiter: '.',
  numeralDecimalMark: ',',
  numeralDecimalScale: 0,
}

export { amountOptions }
